
import { IonItem, IonList, IonLabel, IonChip, IonSearchbar, IonButton, IonIcon, IonRadioGroup, IonRadio, IonListHeader, IonSelect, IonSelectOption } from '@ionic/react';
import { filter } from 'ionicons/icons';
import React from 'react'
import Page from '../components/Page';
import grailItems from '../data/grailItems';

export default class extends React.Component {

  state = {
    searchText: '',
    amountLoad: 50,
    filterOpen: false,
    sortBy: 'none',
    selectedCategory: 'all'
  }

  
  renderFilter(categories) {
    if(this.state.filterOpen) return (
      <IonList style={{marginBottom: 10}} >
        <IonItem>
          <IonLabel>Category</IonLabel>
          <IonSelect value={this.state.selectedCategory} onIonChange={e => this.setState({selectedCategory: e.target.value, amountLoad: 50})}>
            <IonSelectOption value="all">All</IonSelectOption>
            {categories.map(cat => <IonSelectOption key={cat} value={cat}>{cat}</IonSelectOption>)}
          </IonSelect>
        </IonItem>
        <IonRadioGroup value={this.state.sortBy} onIonChange={e => this.setState({sortBy: e.target.value})}>
          <IonListHeader>Sort by</IonListHeader>
          <IonItem>
            <IonLabel>None</IonLabel>
            <IonRadio slot="start" value="none" />
          </IonItem>
          <IonItem>
            <IonLabel>Found items first</IonLabel>
            <IonRadio slot="start" value="foundFirst" />
          </IonItem>
          <IonItem>
            <IonLabel>Items not found first</IonLabel>
            <IonRadio slot="start" value="notFoundFirst" />
          </IonItem>
        </IonRadioGroup>
      </IonList>
    )
  }

  render() {

    // get all items
    const type = this.props.match.params.type;
    let items; 
    let itemsFound
    if(type == 'Unique Items') {
      items = Object.values(grailItems.uniqueItems)
      itemsFound = JSON.parse(localStorage.getItem('uniqueItemsFound'));
    }
    if(type == 'Set Items') {
      items = Object.values(grailItems.setItems)
      itemsFound = JSON.parse(localStorage.getItem('setItemsFound'));
    }

    // sort
    let sorted = items;
    if(this.state.sortBy == 'foundFirst') {
      sorted = sorted.sort((a,b) => {
        if(itemsFound.includes(a.name) && !itemsFound.includes(b.name)) return -1
        if(itemsFound.includes(b.name) && !itemsFound.includes(a.name)) return 1
        return 0;
      })
    } else if(this.state.sortBy == 'notFoundFirst') {
      sorted = sorted.sort((a,b) => {
        if(itemsFound.includes(a.name) && !itemsFound.includes(b.name)) return 1
        if(itemsFound.includes(b.name) && !itemsFound.includes(a.name)) return -1
        return 0;
      })
    }


    // build sorted category list
    const categories = [...new Set(items.map(i => i.category))].sort();

    // filter
    const filtered = sorted.filter(i => {
      if(this.state.selectedCategory !== 'all' && i.category !== this.state.selectedCategory) return false;
      if(i.name.toLowerCase().includes(this.state.searchText.toLowerCase())) return true;
      if(i.type.toLowerCase().includes(this.state.searchText.toLowerCase())) return true;
      return false;
    });
    const sliced = filtered.slice(0,this.state.amountLoad);

    return (
      <Page title={type} large renderButtonsRight={() => {
        return <IonButton onClick={() => {
          this.setState({filterOpen: !this.state.filterOpen})
        }}><IonIcon icon={filter}/></IonButton>
      }}>

        {this.renderFilter(categories)}

        <IonList>
          
          <IonSearchbar value={this.state.searchText} onIonChange={e => this.setState({searchText: e.target.value})} />
          {sliced.map((item,i) => (
            <IonItem key={i} routerLink={'/grail/'+type+'/'+item.name}>
              <IonLabel>
                <h2>{item.name}</h2>
                <p>{item.type}</p>
              </IonLabel>
              {itemsFound.includes(item.name) && <IonChip>found</IonChip>}
            </IonItem>
          ))}
        </IonList>
        <div style={{textAlign: 'center'}}>
          <p>Displaying {sliced.length} out of {items.length}</p>
          {sliced.length < items.length && (
            <IonButton fill="outline" onClick={e => {
              this.setState({amountLoad: this.state.amountLoad + 50})
            }}>Load more</IonButton>
          )}
        </div>
      </Page>
    );
  }
}
